module.exports = __webpack_public_path__ + "media/site_templates/www.tilingquotes.com.au/images/splash-28c203e713abeb30a2e28baa3e210516.jpg";